import { Component, OnInit } from '@angular/core';

export class SettingsLink {
  name: string = '';
  description: string = '';
  icon: string = '';
  link: string = '';
}

export class SettingsSection {
  title: string = '';
  items: SettingsLink[] = [];
}

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit {

  settingsSections: SettingsSection[] = [
    {
      title: 'Users & Access',
      items: [
        {
          name: 'Manage Users', link: '/settings/users',
          icon: 'fas fa-users', description: 'Create, edit and deactivate user accounts.',
        } as SettingsLink,
        {
          name: 'Manage User Roles', link: '/settings/roles',
          icon: 'fas fa-user-shield', description: 'Define what each role in the system can access.',
        } as SettingsLink,
      ],
    },
    {
      title: 'System',
      items: [
        {
          name: 'Environment Settings', link: '/settings/environment',
          icon: 'fas fa-cogs', description: 'Configure environment-level system options.',
        } as SettingsLink,
      ],
    },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
